import { DndContext } from "@dnd-kit/core";

export const KanbanBoardContainer = ({ children, viewMode, title }) => {
  return (
    <div
      style={{
        width: "calc(100%)",
        height: viewMode === "Kanban" ? "calc(100vh)" : "",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        backgroundColor: "white",
        marginTop: "8px",
        paddingInline: "16px",
        paddingTop: "8px",
      }}
    >
      {title && title}
      <div
        style={{
          width: "100%",
          height: viewMode === "Kanban" ? "100%" : "",
          display: "flex",
          overflowX: "auto",
          border: "solid 1px #D2D5DC",
          borderRadius: "8px",
          backgroundColor: "white",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export const KanbanBoard = ({ children, onDragEnd }) => {
  return <DndContext onDragEnd={onDragEnd}>{children}</DndContext>;
};
